export const portalRootId = 'portal-root-id';
